export default __webpack_public_path__ + "static/media/ic_inventory.8a28da97.svg";